module.exports = __webpack_public_path__ + "static/img/la_liga.01341cc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/bg/la_liga.jpg
// module id = zUTF
// module chunks = 1